import React from "react";
import PropTypes from "prop-types";

import fileIcon from "../assets/icons/material-symbols_file-upload.png";
import { X, Folder } from "lucide-react";

const UploadDocumentModal = ({
  show,
  onClose,
  uploadMode,
  setUploadMode,
  uploadedInfo,
  selectedFolder,
  setSelectedFolder,
  onSubmit,
  folderItems,
}) => {
  if (!show) return null;

  // ✅ Root becomes parent of entire tree
  // const rootTree = {
  //   id: null,
  //   name: "Root",
  //   children: folderItems || [],
  // };

  const rootTree = {
    id: null,
    name: "Root",
    children: folderItems || [],
  };

  // ✅ Recursive tree renderer
  const renderFolders = (folders, level = 0) => {
    return folders.map((folder) => {
      const isSelected =
        selectedFolder?.id === folder.id ||
        (selectedFolder === null && folder.id === null);

      return (
        <div key={folder.id ?? "root"}>
          <div
            className={`p-2 rounded mb-1 ${
              isSelected ? "bg-primary text-white" : ""
            }`}
            style={{
              cursor: "pointer",
              marginLeft: `${level * 16}px`,
            }}
            onClick={() => setSelectedFolder(folder)}
          >
            <Folder size={16} /> {folder.name}
          </div>

          {folder.children?.length > 0 &&
            renderFolders(folder.children, level + 1)}
        </div>
      );
    });
  };

  return (
    <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="document-modal modal-content text-center">
          {/* Header */}
          <div className="modal-header justify-content-center p-0 position-relative">
            <button
              type="button"
              className="modal-close-btn position-absolute"
              aria-label="Close"
              onClick={onClose}
            >
              <X size={20} />
            </button>
          </div>

          {/* Body */}
          <div className="modal-body modal-body-padding">
            <div className="d-flex justify-content-center align-items-center mb-3">
              <div className="modal-icon-wrapper rounded-circle d-flex justify-content-center align-items-center p-3">
                <img
                  src={fileIcon}
                  alt="Upload"
                  style={{ width: "36px", height: "36px" }}
                />
              </div>
            </div>

            <h5 className="fw-semibold mb-2">Upload Documents</h5>

            <p className="mb-2">
              You have uploaded <strong>{uploadedInfo.count}</strong>{" "}
              {uploadedInfo.type}
              {uploadedInfo.count > 1 ? "s" : ""}.
            </p>

            <p className="mb-3">
              Select the repository and destination folder.
            </p>

            {/* Repository Mode */}
            <div className="d-flex justify-content-center gap-4 mb-3">
              {["Global", "Personal"].map((mode) => (
                <label
                  key={mode}
                  className="form-check custom-form-check d-flex align-items-center gap-2 pl-0"
                >
                  <input
                    type="radio"
                    className="custom-radio"
                    name="uploadMode"
                    value={mode}
                    checked={uploadMode === mode}
                    onChange={() => {
                      setUploadMode(mode);
                      setSelectedFolder({
                        id: null,
                        name: "Root",
                      });
                    }}
                  />
                  <span>{mode}</span>
                </label>
              ))}
            </div>

            {/* Folder Tree */}
            <div
              className="border rounded p-2 text-start"
              style={{
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              {folderItems.length === 0 ? (
                <div className="text-center text-muted py-5">
                  No folders found.
                </div>
              ) : (
                renderFolders([rootTree])
              )}
            </div>

            {/* Selected Folder Info */}
            <div className="mt-3 text-start">
              <small className="text-success">
                Selected Folder:{" "}
                <strong>{selectedFolder ? selectedFolder.name : "Root"}</strong>
              </small>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer justify-content-center gap-3">
            <button
              type="button"
              className="cancle-btn w-25 border border-1 fw-semibold"
              onClick={onClose}
            >
              Cancel
            </button>

            <button
              type="button"
              className="custom-btn w-25"
              // disabled={uploadedInfo.count === 0}
              onClick={onSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

UploadDocumentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  uploadMode: PropTypes.string.isRequired,
  setUploadMode: PropTypes.func.isRequired,
  uploadedInfo: PropTypes.shape({
    count: PropTypes.number,
    type: PropTypes.string,
  }).isRequired,
  selectedFolder: PropTypes.object,
  setSelectedFolder: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  folderItems: PropTypes.array.isRequired,
};

export default UploadDocumentModal;
